import { render, staticRenderFns } from "./inventoryReminder.vue?vue&type=template&id=76fbf3ec"
import script from "./inventoryReminder.vue?vue&type=script&lang=js"
export * from "./inventoryReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports